
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import apiCustom from "../../utils/ApiCustom";

export const fetchCategoryByType = createAsyncThunk(
  "categories/fetchCategories",
  async (type) => {
    const response = await apiCustom.get(`categories?t=${type || "category"}`);
    return response.data?.data?.data;
  }
);
export const fetchCategoryByTypePublic = createAsyncThunk(
  "categories/fetchCategoriesPublic",
  async (type) => {
    const response = await apiCustom.get(
      `categories/public?t=${type || "category"}`
    );
    if (type) {
      return type == "company" || type == "category"
        ? response.data?.data?.data
        : response.data?.data?.data?.filter((e) => e.permissionId !== null);
    } else {
      return response.data?.data?.data;
    }
  }
);
export const saveCategoty = createAsyncThunk(
  "categories/saveCategoty",
  async (newPost, { rejectWithValue }) => {
    try {
      const response = await apiCustom.post("/categories", newPost, {
        headers: {
          "Content-Type": "application/json",
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);
export const updateCategory = createAsyncThunk(
  "categories/updateCategory",
  async ({ id, dataUpdate }, { rejectWithValue }) => {
    try {
      const response = await apiCustom.put(`/categories/${id}`, dataUpdate);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Đã xảy ra lỗi!");
    }
  }
);
export const deleteCategory = createAsyncThunk(
  "categories/deleteCategory",
  async (id, { rejectWithValue }) => {
    try {
      const response = await apiCustom.delete(`/categories/${id}`);
      return { response };
    } catch (error) {
      return rejectWithValue(error.response?.data || "Đã xảy ra lỗi!");
    }
  }
);
const postsSlice = createSlice({
  name: "categories",
  initialState: {
    categories: [],
    navbars: [],
    status: "idle",
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchCategoryByType.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchCategoryByType.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.categories = action.payload;

        const requestedTypes = String(action.meta.arg || "category").split(",");
        if (
          requestedTypes.includes("navbar") ||
          requestedTypes.includes("notification")
        ) {
          state.navbars =
            action.payload?.filter(
              (cate) =>
                cate.type === "navbar" || cate.type === "notification"
            ) || [];
        }
      })
      .addCase(fetchCategoryByTypePublic.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.categories = action.payload;

        const requestedTypes = String(action.meta.arg || "category").split(",");
        if (
          requestedTypes.includes("navbar") ||
          requestedTypes.includes("notification")
        ) {
          state.navbars =
            action.payload?.filter(
              (cate) =>
                cate.type === "navbar" || cate.type === "notification"
            ) || [];
        }
      })
      .addCase(fetchCategoryByType.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })

      // Add cate
      .addCase(saveCategoty.fulfilled, (state) => {
        state.status = "idle";
      })

      // // Update cate
      .addCase(updateCategory.fulfilled, (state) => {
        state.status = "idle";
      })

      // // Delete cate
      .addCase(deleteCategory.fulfilled, (state) => {
        state.status = "idle";
      });
  },
});

export default postsSlice.reducer;

